import React from 'react';
import {Tag} from 'antd';
import {useTranslation} from 'react-i18next';
import {ComplaintOrgMemberType} from '../../../../graphql/complaintOrg/types';

interface MemberChipProps {
  member: ComplaintOrgMemberType;
  onClick: (member: ComplaintOrgMemberType) => void;
}

/**
 * 人员 chip：正常紫色；系统账号已停用 / 已离职为橙色并带原因（需换人）。
 * 点击打开人员详情，移除在详情里操作；不能改手机号——换人 = 删除后重新添加。
 */
const MemberChip: React.FC<MemberChipProps> = ({member, onClick}) => {
  const {t} = useTranslation();
  const abnormal = member.accountStatus !== 'NORMAL';

  return (
    <Tag
      color={abnormal ? 'orange' : 'purple'}
      className="!mr-0 !py-0.5 !text-sm cursor-pointer"
      onClick={() => onClick(member)}
    >
      {member.name}
      {abnormal && (
        <span className="text-xs"> · {t(`complaintOrg.status.${member.accountStatus}`)}</span>
      )}
    </Tag>
  );
};

export default MemberChip;
